module.exports = __webpack_public_path__ + "static/media/019.3b9d3432.jpg";